import { useQuasarPlugin } from '@mfl/common-components';
import { bootstrapMicrofrontend } from '@mfl/vue-common';
import { router } from './router';

import mfe from './account-settings-mfe.vue';

const { bootstrap, mount, unmount } = bootstrapMicrofrontend({
  name: 'account-settings',
  mainComponent: mfe,
  targetElement: '#content',
  includeCss: true,
  viteCdnPrefix: import.meta.env.VITE_CDN_PREFIX,
  handleVueApp: (app) => {
    useQuasarPlugin(app);
    app.use(router);
  },
});

export { bootstrap, mount, unmount };
